import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONFIG } from '../../config';
import { AbstractCRUD, CRUDService, ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { Link } from '../../shared/models/link.model';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LinkService extends AbstractCRUD<Link> implements CRUDService<Link> {
  private config = CONFIG;

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService
  ) {
    super(exceptionService, http, utilsService);
  }

  getResourcePath(): string {
    return '/rms/qrsLinks';
  }

  public saveOrdering(ids: Array<number>): Observable<any> {
    const url = `${super.getApiPath()}/reorder`;
    return super.getHTTP().post<Array<number>>(url, ids)
      .pipe(
        catchError(
          ex => super.getException().catchBadResponse(ex)
        )
      );
  }

}
